import React from 'react';
import './Coordinates.css';
import { Mail, Linkedin } from 'lucide-react';

const CONTACT_ITEMS = [
  {
    testId: 'contact-email',
    icon: <Mail size={20} strokeWidth={1.5} aria-hidden="true" />,
    content: (
      <a href="mailto:vman747@gmail.com" aria-label="Email vman747@gmail.com">
        vman747@gmail.com
      </a>
    ),
  },
  {
    testId: 'contact-linkedin',
    icon: <Linkedin size={20} strokeWidth={1.5} aria-hidden="true" />,
    content: (
      <a
        href="https://www.linkedin.com/in/vishaalv8"
        target="_blank"
        rel="noopener noreferrer"
        aria-label="LinkedIn profile: linkedin.com/in/vishaalv8 (opens in new tab)"
      >
        LinkedIn → linkedin.com/in/vishaalv8
      </a>
    ),
  },
  {
    testId: 'contact-resilience',
    icon: null,
    content: (
      <>
        <span>For Resilience inquiries →</span>
        <a
          href="https://cyberresilience.com"
          target="_blank"
          rel="noopener noreferrer"
          aria-label="Resilience inquiries at cyberresilience.com (opens in new tab)"
        >
          cyberresilience.com
        </a>
      </>
    ),
  },
  {
    testId: 'contact-critical-guard',
    icon: null,
    content: (
      <>
        <span>For Critical Guard inquiries →</span>
        <a
          href="https://criticalguard.org"
          target="_blank"
          rel="noopener noreferrer"
          aria-label="Critical Guard inquiries at criticalguard.org (opens in new tab)"
        >
          criticalguard.org
        </a>
      </>
    ),
  },
];

const Coordinates = () => {
  return (
    <section className="coordinates" id="coordinates" data-testid="coordinates-section">
      <div className="section-content">
        <h2 className="section-header" data-testid="coordinates-header">Coordinates</h2>

        <div className="contact-items" data-testid="contact-items">
          {CONTACT_ITEMS.map(({ testId, icon, content }) => (
            <div
              key={testId}
              className={`contact-item${icon ? '' : ' contact-note'}`}
              data-testid={testId}
            >
              {icon}
              {content}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Coordinates;
